import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-20 bg-background" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col gap-6" data-id="element-4">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground" data-id="element-5">
              Dedicated to Your Healing
            </h2>
            <p className="text-lg text-muted-foreground" data-id="element-6">
              At The Neuropathy & Healing Center, we understand how debilitating
              nerve pain can be. It steals your sleep, limits your mobility, and
              keeps you from enjoying life with your loved ones.
            </p>
            <p className="text-lg text-muted-foreground" data-id="element-7">
              Our clinic was founded on a simple philosophy: patients deserve
              better than a lifetime of prescription medications that only mask
              symptoms while the underlying condition worsens.
            </p>
            <p className="text-lg text-muted-foreground" data-id="element-8">
              We combine cutting-edge, FDA-cleared medical technologies with
              comprehensive nutritional and lifestyle protocols to create an
              environment where your nerves can actually heal.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-9">
            <div className="aspect-square rounded-2xl overflow-hidden shadow-xl" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/xeuUNc3emxx5rmVxkRkg21/neuropathy_team_photo_2.jpg" alt="The care team at The Neuropathy & Healing Center" className="object-cover w-full h-full" data-id="element-11" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}